<template>
    <div class="page flexcolumn">
      <div class="jp-common-layout ">
        <div class="jp-common-layout-left" style="width: 200px;">
          <div class="jp-common-title flexTreeTitle"> 
          <el-input
            placeholder="请输入关键字进行过滤"
            style="width: 100%;"
            size="small"
            clearable
            v-model="filterText">
          </el-input>
        </div>
        <div class="jp-common-el-tree-scrollbar el-scrollbar">
          <div class="el-scrollbar__wrap" :style="{height: treeHeight-40 +'px'}">
            <div class="el-scrollbar__view" style="">
                <!-- <vxe-table
                  show-overflow
                  :loading="loading"
                  border="none"
                  ref="xTree"
                  :show-header="false"
                  :tree-config="{transform: true, rowField: 'id', parentField: 'parentId'}"
                  :radio-config="{labelField: 'nameCn'}"
                  :row-config="{keyField:'id',isCurrent: true, isHover: true}"
                  :data="showTreeList">
                  <vxe-column field="nameCn" tree-node>
                    <template slot-scope="scope">
                      <div style="width: 100%;" @click="handRow(scope.row, 'row')">{{ scope.row.label }}</div>
                    </template>
                  </vxe-column>
                </vxe-table> -->
                <el-tree
              class="filter-tree jp-common-el-tree"
              :data="showTreeList"
              :props="{
                    value: 'id',             // ID字段名
                    label: 'label',         // 显示名称
                    children: 'children'    // 子级字段名
                  }"
              node-key="id"
              default-expand-all
              :filter-node-method="filterNode"
              :expand-on-click-node="false"
              highlight-current
              @node-click="handRow"
              ref="officeTree">
            </el-tree>
            </div>
          </div>
        </div>
        </div>
        <div class="jp-common-layout-center jp-flex-main">
          <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm" @keyup.enter.native="refreshList()" @submit.native.prevent>
            <!-- 搜索框-->
            <el-form-item prop="nameEn">
                    <el-input size="small" v-model="searchForm.nameEn" placeholder="标签名称（英）" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item prop="associationType">
              <el-select
                v-model="searchForm.associationType"
                clearable
                placeholder="类型"
                style="width: 180px"
              >
                <el-option
                  v-for="item in $dictUtils.getDictList('cec_tags_type')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item> -->
              <el-form-item>
                <el-button type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
              </el-form-item>
              <el-form-item style="float: right;">
                <el-button v-if="hasPermission('cecunmtagcloud:cecUnmTagCloud:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button>
                <!-- <el-button v-if="hasPermission('cecunmtagcloud:cecUnmTagCloud:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.cecUnmTagCloudTable && $refs.cecUnmTagCloudTable.getCheckboxRecords().length !== 1" plain>编辑</el-button> -->
              </el-form-item>
          </el-form>

          <div class="bg-white top">
              
              <!-- <vxe-toolbar :refresh="{query: refreshList}" import export print custom>
                <template #buttons>
                  <el-button v-if="hasPermission('cecunmtagcloud:cecUnmTagCloud:add')" type="primary" size="small" icon="el-icon-plus" @click="add()">新建</el-button>
                  <el-button v-if="hasPermission('cecunmtagcloud:cecUnmTagCloud:edit')" type="warning" size="small" icon="el-icon-edit-outline" @click="edit()" :disabled="$refs.cecUnmTagCloudTable && $refs.cecUnmTagCloudTable.getCheckboxRecords().length !== 1" plain>修改</el-button>
                  <el-button v-if="hasPermission('cecunmtagcloud:cecUnmTagCloud:del')" type="danger"   size="small" icon="el-icon-delete" @click="del()" :disabled="$refs.cecUnmTagCloudTable && $refs.cecUnmTagCloudTable.getCheckboxRecords().length === 0" plain>删除</el-button>
                </template>
                <template #tools>
                  <vxe-button
                type="default"
                title="下载导入模板"
                v-if="hasPermission('cecunmtagcloud:cecUnmTagCloud:import')"
                class="el-icon-document m-r-12"
                @click="downloadTpl()"
                circle
                  >
                  </vxe-button>
                </template>
              </vxe-toolbar> -->
              <div style="height: calc(100% - 30px);overflow: auto;" v-loading="loading">
                <div class="content">
                  <el-tag
                    v-for="(tag ,index) in dataList"
                    :key="index"
                    class="singleTag"
                    :closable="hasPermission('cecunmtagcloud:cecUnmTagCloud:del')"
                    @close="handleCloseTag(tag)"
                  >
                    {{ tag.nameEn }}
                    <i v-if="hasPermission('cecunmtagcloud:cecUnmTagCloud:edit')" class="el-icon-edit iconEdit" @click.stop="edit(tag.id)"></i>
                  </el-tag>
                </div>
              </div>
          </div>
        </div>
      </div>
      
        <!-- 弹窗, 新增 / 修改 -->
    <CecUnmTagCloudForm  ref="cecUnmTagCloudForm" @refreshDataList="refreshList"></CecUnmTagCloudForm>
  </div>
</template>

<script>
  import CecUnmTagCloudForm from './CecUnmTagCloudForm'
  import cecUnmTagCloudService from '@/api/cecunmtagcloud/cecUnmTagCloudService'
  export default {
    data () {
      return {
        searchForm: {
          nameEn: '',
          associationType: ''
        },
        dataList: [],
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 1000,
          orders: [{ column: 'create_date', asc: false }]
        },
        loading: false,
        filterText: '',
        showTreeList: [],
        treeHeight: '',
        currentValue: ''
      }
    },
    watch: {
      filterText (val) {
        this.$refs.officeTree.filter(val)
      }
    },
    components: {
      CecUnmTagCloudForm
    },
    activated () {
      this.showTreeList = this.$dictUtils.getDictList('cec_tags_type')
      this.$nextTick(() => {
        if (this.showTreeList.length > 0) {
          this.$refs.officeTree.setCurrentKey(this.showTreeList[0].id)
          this.searchForm.associationType = this.showTreeList[0].value
          this.currentValue = this.showTreeList[0].value
        }
        this.treeHeight = document.getElementsByClassName('jp-common-el-tree-scrollbar')[0].offsetHeight
        this.refreshList()
      })
    },
    methods: {
      filterNode (value, data) {
        if (!value) return true
        return data.label.indexOf(value) !== -1
      },
      handRow (row, type) {
        this.currentValue = row.value
        this.searchForm.associationType = row.value
        this.refreshList()
      },
      handleCloseTag (tag) {
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecUnmTagCloudService.delete(tag.id).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        cecUnmTagCloudService.list({
          'current': this.tablePage.currentPage,
          'size': this.tablePage.pageSize,
          'orders': this.tablePage.orders,
          ...this.searchForm
        }).then(({data}) => {
          this.dataList = data.records
          this.tablePage.total = data.total
          this.loading = false
        })
      },
      // 当前页
      currentChangeHandle ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.refreshList()
      },
      // 排序
      sortChangeHandle (obj) {
        this.tablePage.orders = []
        if (obj.order != null) {
          this.tablePage.orders = [{ column: obj.column.sortBy || this.$utils.toLine(obj.property), asc: obj.order === 'asc' }]
        } else {
          this.tablePage.orders = [{ column: 'create_date', asc: false }]
        }
        this.refreshList()
      },
      // 新增
      add () {
        this.$refs.cecUnmTagCloudForm.init('add', '', this.currentValue)
      },
      // 修改
      edit (id) {
        id = id || this.$refs.cecUnmTagCloudTable.getCheckboxRecords().map(item => {
          return item.id
        })[0]
        this.$refs.cecUnmTagCloudForm.init('edit', id)
      },
      // 查看
      view (id) {
        this.$refs.cecUnmTagCloudForm.init('view', id)
      },
      // 删除
      del (id) {
        let ids = id || this.$refs.cecUnmTagCloudTable.getCheckboxRecords().map(item => {
          return item.id
        }).join(',')
        this.$confirm(`确定删除所选项吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cecUnmTagCloudService.delete(ids).then(({data}) => {
            this.$message.success(data)
            this.refreshList()
            this.loading = false
          })
        })
      },
      // 下载模板
      downloadTpl () {
        this.loading = true
        cecUnmTagCloudService.exportTemplate().then(({data}) => {
    // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, '请假表单导入模板')
          this.loading = false
        }).catch(function (err) {
          this.loading = false
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      // 自定义服务端导入
      importMethod ({ file }) {
      // 处理表单
        const formBody = new FormData()
        formBody.append('file', file)
        this.loading = true
        cecUnmTagCloudService.importExcel(formBody).then(({data}) => {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: data
          })
          this.refreshList()
        })
      },
      // 自定义服务端导出
      exportMethod ({ options }) {
      // 传给服务端的参数
        const params = {
          current: this.tablePage.currentPage,
          size: this.tablePage.pageSize,
          orders: this.tablePage.orders,
          ...this.searchForm,
          filename: options.filename,
          sheetName: options.sheetName,
          isHeader: options.isHeader,
          original: options.original,
          mode: options.mode,
          selectIds: options.mode === 'selected' ? options.data.map((item) => item.id) : [],
          exportFields: options.columns.map((column) => column.property && column.property.split('.')[0])
        }
        this.loading = true
        return cecUnmTagCloudService.exportExcel(params).then(({data}) => {
      // 将二进制流文件写入excel表，以下为重要步骤
          this.$utils.downloadExcel(data, options.filename)
          this.loading = false
        }).catch(function (err) {
          if (err.response) {
            console.log(err.response)
          }
        })
      },
      resetSearch () {
        this.$refs.searchForm.resetFields()
        this.refreshList()
      }
    }
  }
</script>
<style scoped lang="less">
.flexcolumn{
  display: flex;
  flex-direction: column;
}
.content{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.singleTag {
  margin-left: 5px;
  margin-bottom: 5px;
}
.iconEdit{
  border-radius: 50%;
  text-align: center;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  vertical-align: middle;
  top: -1px;
  right: -5px;
  cursor: pointer;
  padding: 2px;
}
.iconEdit:hover{
  border-radius: 10px;
  background-color: #409eff;
  color: white;

}
</style>

